import {IDrawPredictorStore} from "apps/DRAW_PREDICTOR/modules/types/store";
import {createSelector} from "reselect";
import {Pots} from "apps/DRAW_PREDICTOR/modules/enums";
import {filter, size} from "lodash";

export const getSquads = (state: IDrawPredictorStore) => state.squads.squads;

export const getSquadsByPots = createSelector(getSquads, (squads) => {
	return {
		[Pots.POT1]: filter(squads, (squad) => squad.pot === 1),
		[Pots.POT2]: filter(squads, (squad) => squad.pot === 2),
		[Pots.POT3]: filter(squads, (squad) => squad?.pot === 3),
		[Pots.POT4]: filter(squads, (squad) => squad?.pot === 4),
	};
});

export const getSquadsByPot = createSelector(
	getSquads,
	(squads) => (pot: number) => filter(squads, (squad) => squad.pot === pot)
);

export const isAllFilled = createSelector(getSquads, (squads) => {
	const notFilled = filter(squads, (squad) => !squad.position || !squad.group);

	return size(notFilled) === 0;
});
